import {Grid, MenuItem, Select} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {useEffect, useState} from 'react';
import dynamic from 'next/dynamic';
import RootStore from '../Core/mobx/RootStore';

const Plot = dynamic(import('react-plotly.js'), {ssr: false});

export const AnalyticsPanel = observer(() => {
    const forms = RootStore.caseManagerStore.forms;
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if (!forms?.length) {
                setLoading(true);
                await RootStore.caseManagerStore.getForms();
                setLoading(false);
            }
        })();
    }, []);

    if (forms == null) {
        return null;
    }
    console.log('AalyticsPanel', performance.now());

    const [formType, setFormType] = useState('all');

    const fforms = forms.filter((x) => {
        switch (formType) {
            case 'all':
                return true;
            case 'prequal':
                return x.v.formPreQual;
            case 'preappr':
                return x.v.formPreApproval;
        }
    });

    const dates = Array.from(new Set(fforms.map((f) => f.p)));
    const agents = Array.from(new Set(fforms.map((f) => f.v.agent)));
    const data = new Array<{agent: string; dates: Array<{date: string; count: number}>}>();

    agents.forEach((a) => {
        var ad = {agent: a, dates: new Array<{date: string; count: number}>()};
        dates.forEach((d) => {
            const i = {date: d, count: fforms.filter((f) => f.p == d && f.v.agent == a).length};
            if (i.count > 0) {
                ad.dates.push(i);
            }
        });
        data.push(ad);
    });

    return (
        <Grid container spacing={3}>
            {loading ? (
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    loading, please wait...
                </Grid>
            ) : (
                <>
                    <Grid item xs={12}>
                        <Select
                            value={formType}
                            onChange={(e) => {
                                setFormType(e.target.value as string);
                            }}
                        >
                            <MenuItem value={'all'}>All Form Types</MenuItem>
                            <MenuItem value={'prequal'}>Pre-qualification</MenuItem>
                            <MenuItem value={'preappr'}>Pre-approval</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{width: '100%'}}>
                            <Plot
                                style={{width: '100%', height: '300px'}}
                                data={data.map((a) => {
                                    return {
                                        name: a.agent,
                                        type: 'bar',
                                        x: a.dates.map((x) => x.date),
                                        y: a.dates.map((x) => x.count),
                                    };
                                })}
                                layout={{
                                    title: 'Daily Form Submission (Last 7 Days)',
                                    autosize: true,
                                    barmode: 'stack',
                                }}
                            />
                        </div>
                    </Grid>
                </>
            )}
        </Grid>
    );
});
